import { baseInputTheme } from '../BaseInput/theme'

export const inputTheme = {
  ...baseInputTheme,
}
